// A dónde sube PhotoUploader cada foto (backend/storage.py): las del cliente, con el código de su reserva; las
// del panel de una reserva (entrega, daños, devolución, inspección), privadas y ligadas a ella; las demás del
// panel que pasan por PhotoUploader (vehículos, productos), públicas. Sin destino, la foto se queda en base64.
// (El logo no pasa por aquí: CompanySettings lo sube directamente a /admin/uploads, público.)
export function destinoSubida({ uploadCode = null, adminUpload = false, reservationId = null } = {}) {
  if (adminUpload) {
    return reservationId ? `/admin/uploads?reservation_id=${encodeURIComponent(reservationId)}` : "/admin/uploads";
  }
  if (uploadCode) return `/uploads?code=${encodeURIComponent(uploadCode)}`;
  return null;
}
